import {connect} from 'react-redux';
import {PrepareGelBox as Component} from './PrepareGelBox';
import {
  showModal,
  prepareGelBox
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    //solutions: state.notebook.protocolSection.scene.apparatus.solutions
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    prepareGelBox: (data) => {
      dispatch(prepareGelBox(data))
    }
  };
}

export const PrepareGelBox = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
